import ApiRequest from '../request'

export default class Votes {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async delete(id) {
    try {
      const res = await this.apiRequest.delete(`votes/${id}`)
      return res
    } catch (error) {
      return error.response
    }
  }
}
